import cn from 'classnames';
import { Card } from '../cards';
import st from './styles.module.scss';

type PT = {
  className?: string;
};

export const Skeleton = () => {
  return (
    <Card className={st.card}>
      <div className={st.card__status_image}>
        <div className={st.card__image}></div>
      </div>
      <div className={st.card__data}>
        <section className={st.card__top}>
          <div className={st.card__title}></div>
          <div className={st.card__title}></div>
        </section>
        <div className={st.card__bottom}>
          <div className={st.card__details}>
            <div className={st.card__description}></div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export const SkeletonList = ({ className }: PT) => {
  const array = new Array(5);
  return (
    <div className={cn(st.skeletonList, className)}>
      {[...array].map((_, index) => (
        <Skeleton key={index} />
      ))}
    </div>
  );
};
